import React from 'react';
import {Helmet} from 'react-helmet-async';
import {connect} from "react-redux";
import moment from 'moment';

const SeoCompSupplier = ({title, image,description, supplier}) => {
    const truncateDescription = description.slice(0, 150);

    const phone = supplier?.personalData?.phone;
    const reviews = supplier?.personalData?.reviews;
    const services = supplier?.activities;
    const address = supplier?.personalData?.address;

    const canonicalUrl = `${window.location.origin}${window.location.pathname}`;

    return <Helmet>
        <title>{title}</title>
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={title} />
        <meta property="og:type" content="profile" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:image" content={image} />
        <meta property="og:description" content={truncateDescription} />
        <meta property="og:site_name" content="Agendia" />
        <meta name="description" content={truncateDescription} />
        <script type="application/ld+json">
{JSON.stringify({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": title,
  "image": image,
  "url": canonicalUrl,
  "telephone": phone,
  ...(address && {"address": {
    "@type": "PostalAddress",
    "streetAddress": address?.address?.street,
    "addressLocality": address?.address?.city,
    "addressRegion": address?.address?.state,
    "addressCountry": address?.address?.countryName
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": address?.position?.lat,
    "longitude": address?.position?.lng
  }}),
...(reviews && {
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": reviews?.reduce((acc,value)=>acc+value.rating,0) / reviews.length,
    "reviewCount": reviews?.length
  },
  "review": reviews?.map(review=>({
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": review?.name
      },
      "datePublished": formatDate(review?.date),
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": review?.rating,
        "bestRating": "5"
      },
      "reviewBody": review?.text
    })),
    }),
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Servicios de Psicoterapia",
    "itemListElement": services?.map(service=>({
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": service?.subProfessionId?.heName,
          "price": service?.price,
          "priceCurrency": "MXN",
          "duration":`PT${service?.duration}M`
        }
      })),
  }
})}
</script>
    </Helmet>
}

const mapStateToProps = (state) => ({
    supplier: state.general.supplier
})

export default connect(mapStateToProps)(SeoCompSupplier);
const formatDate = (dateString)=>{const momentObject = moment(dateString, "DD.M.YYYY"); // Parse with the correct input format
return  momentObject.format("YYYY-MM-DD"); // Format to the desired output
}
